import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["message", "file", "submit"]

  submitStart() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = true
  }

  submitEnd(event) {
    if (this.hasSubmitTarget) this.submitTarget.disabled = false
    if (!event.detail.success) return

    this.element.reset()

    if (this.hasMessageTarget) {
      this.messageTarget.value = ""
      this.messageTarget.style.height = ""
      this.messageTarget.focus()
    }

    if (this.hasFileTarget) {
      this.fileTarget.value = ""
    }
  }
}
